// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._500 {\n  height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n._500 ._5-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 66.667vw;\n  padding: 13.333vw 0;\n}\n._500 ._5-content img {\n  width: 100%;\n}\n._500 ._5-content p {\n  padding-top: 2.667vw;\n  white-space: nowrap;\n  color: #999999;\n  font-size: 4vw;\n}\n", ""]);
// Exports
module.exports = exports;
